import { render, staticRenderFns } from "./BaseCollapsibleSwitchForm.vue?vue&type=template&id=9ba95a1e&scoped=true"
import script from "./BaseCollapsibleSwitchForm.vue?vue&type=script&lang=js"
export * from "./BaseCollapsibleSwitchForm.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapsibleSwitchForm.vue?vue&type=style&index=0&id=9ba95a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba95a1e",
  null
  
)

export default component.exports